var _path, _ellipse, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrabalhar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8938 31V28H63.0947V31H30.8938ZM31.1446 60V47.1H28.6869V44.1L30.8938 34H63.0445L65.2514 44.1V47.1H62.7937V60H59.7843V47.1H50.3046V60H31.1446ZM34.154 57H47.2952V47.1H34.154V57ZM31.6462 44.1H62.2921L60.7373 37H33.201L31.6462 44.1Z",
    fill: "#737791"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.7937,
    cy: 32,
    rx: 10.0314,
    ry: 10,
    fill: "#737791"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9806_103946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4897 33.75H64.9944L64.8188 33.5812C65.4332 32.8687 65.8031 31.9437 65.8031 30.9375C65.8031 28.6938 63.9787 26.875 61.7279 26.875C59.4771 26.875 57.6526 28.6938 57.6526 30.9375C57.6526 33.1813 59.4771 35 61.7279 35C62.7373 35 63.6652 34.6313 64.3799 34.0188L64.5492 34.1937V34.6875L67.684 37.8062L68.6182 36.875L65.4897 33.75ZM61.7279 33.75C60.1667 33.75 58.9065 32.4938 58.9065 30.9375C58.9065 29.3812 60.1667 28.125 61.7279 28.125C63.289 28.125 64.5492 29.3812 64.5492 30.9375C64.5492 32.4938 63.289 33.75 61.7279 33.75Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3879 46C92.3879 71.1275 71.9537 91.5 46.7434 91.5C21.5332 91.5 1.09894 71.1275 1.09894 46C1.09894 20.8725 21.5332 0.5 46.7434 0.5C71.9537 0.5 92.3879 20.8725 92.3879 46Z",
    stroke: "#737791"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9806_103946"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.7717,
    y: 25,
    width: 15.0471,
    height: 15,
    rx: 7.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrabalhar);
export default __webpack_public_path__ + "static/media/trabalhar.3232cf97.svg";
export { ForwardRef as ReactComponent };